export const version = "contracts/5.4.1";
//# sourceMappingURL=_version.js.map